
import React, { PropTypes, Component } from 'react';
import classnames from 'classnames';

import './style.scss';
import Link from 'components/Link';
import UserAvatar from 'components/UserAvatar';

class Comment extends Component {

  constructor() {
    super();

    this.handleMarkAsUsefulClick = this.handleMarkAsUsefulClick.bind(this);
    this.handleUnmarkAsUsefulClick = this.handleUnmarkAsUsefulClick.bind(this);
    this.handleReplyClick = this.handleReplyClick.bind(this);
    this.handleRepliesClick = this.handleRepliesClick.bind(this);
    this.handleHideRepliesClick = this.handleHideRepliesClick.bind(this);
  }

  handleMarkAsUsefulClick(event) {
    event.preventDefault();
    this.props.onMarkAsUseful && this.props.onMarkAsUseful(this.props.commentId);
  }

  handleUnmarkAsUsefulClick(event) {
    event.preventDefault();
    this.props.onUnmarkAsUseful && this.props.onUnmarkAsUseful(this.props.commentId);
  }

  handleReplyClick(event) {
    event.preventDefault();
    this.props.onReply && this.props.onReply(this.props.commentId);
  }

  handleRepliesClick(event) {
    event.preventDefault();
    this.props.onViewReplies && this.props.onViewReplies(this.props.commentId);
  }

  handleHideRepliesClick(event) {
    event.preventDefault();
    this.props.onHideReplies && this.props.onHideReplies(this.props.commentId);
  }

  render() {
    const childrenCount = React.Children.count(this.props.children);

    const className = classnames('Comment', {
      'is-expanded': childrenCount > 0,
      'is-empty': this.props.isEmpty,
      'is-highlighted': this.props.isHighlighted,
      'is-root': this.props.isRoot
    });

    return (
      <div className={className}>
        <div className="head">
          <div className="author">
            <div className="avatar">
              <UserAvatar imageUrl={this.props.authorAvatar} />
            </div>
            <div className="name">{this.props.authorName}</div>
          </div>

          {this.props.isPinned && <div className="pinned-label float-right">{__('members.comments.pinned')}</div>}
          <div className="time float-right">{this.props.since}</div>
        </div>

        <div className="text">
          <p>{this.props.text}</p>
        </div>

        <div className="buttons">
          {(() => {
            if(this.props.canBeMarkedAsUseful) {
              if(this.props.isMarkedAsUseful) {
                return <Link onClick={this.handleUnmarkAsUsefulClick}>{__('members.comments.unmarkUseful')}</Link>;
              }

              return <Link onClick={this.handleMarkAsUsefulClick}>{__('members.comments.markUseful')}</Link>;
            }
          })()}


          {this.props.canBeRepliedTo && <Link onClick={this.handleReplyClick}>{__('members.comments.reply')}</Link>}

          {(() => {
            if(childrenCount > 0) {
              return <span onClick={this.handleHideRepliesClick} className="replies-count float-right clickable">{__('members.comments.hideReplies')}</span>;
            }
            else if(this.props.canBeRepliedTo) {
              const className = classnames('replies-count', 'float-right', {'clickable': this.props.canViewReplies});
              return <span onClick={this.handleRepliesClick} className={className}>{this.props.repliesInfo}</span>;
            }
          })()}
        </div>

        {(() => {
          if(childrenCount > 0) {
            return (
              <div className="replies">
                {this.props.children}
              </div>
            );
          }
        })()}
      </div>
    );
  }
}

Comment.propTypes = {
  commentId: PropTypes.number,
  children: PropTypes.arrayOf(PropTypes.element),
  text: PropTypes.array,
  isPinned: PropTypes.bool,
  authorName: PropTypes.string,
  authorAvatar: PropTypes.string,
  since: PropTypes.string,
  isMarkedAsUseful: PropTypes.bool,
  isRoot: PropTypes.bool,
  canBeRepliedTo: PropTypes.bool,
  canViewReplies: PropTypes.bool,
  repliesInfo: PropTypes.string,
  isEmpty: PropTypes.bool,
  canBeMarkedAsUseful: PropTypes.bool,
  isHighlighted: PropTypes.bool,
  onMarkAsUseful: PropTypes.func,
  onUnmarkAsUseful: PropTypes.func,
  onReply: PropTypes.func,
  onCancelReply: PropTypes.func,
  onViewReplies: PropTypes.func,
  textEditorRenderer: PropTypes.func,
  onHideReplies: PropTypes.func
};

export default Comment;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/CommentsList/Comment/index.js
 **/